export const toOption = (item) =>
  typeof item === 'string' ? { value: item, label: item } : item;

export const getOptionLabel = (options, value) =>
  options.find((option) => option.value === value)?.label || value;
